import TimelineGroup from './TimelineGroup';

(() => {
  /**
   * Initialise any/all components on the page.
   *
   * Note: We assume there may be more than one
   * instance of this component on the page.
   */
  const componentNodeList = document.querySelectorAll('[data-component="timeline-group"]');

  componentNodeList.forEach((component) => {
    TimelineGroup(component as HTMLElement);
  });

})();
